import {
  PaymentDetailsHeaderStart, PaymentDetailsHeaderEnter, PaymentDetailsArrow, PaymentDetailsContainer,
  PaymentDetailsInfoText, PaymentDetailsInfoTextBold, PaymentDetailsInfoTextContainer, PaymentDetailsTextContainerDue,
  PaymentDetailsTextContainerSubscribing,
} from "views/PaymentFlow/PaymentDetails/PaymentDetails.styles";
import {Elements, useElements, useStripe} from "@stripe/react-stripe-js";
import {loadStripe} from "@stripe/stripe-js/pure";
import StripeForm from "views/PaymentFlow/StripeForm/StripeForm"
import {useAppSelector} from "store/hooks";
import {useEffect, useState} from "react";
import * as PaymentServiceApi from 'apis/PaymentService';
import {PaymentIntent, PaymentIntentResult, StripeElementsOptions} from "@stripe/stripe-js";
import {useCreateSubscription} from "apis/PaymentService";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISH_LIVE);

function PaymentDetails() {
  const plan = useAppSelector(state => state.subscriptionPlan);

  const {loading, error, response} = PaymentServiceApi.useCreateSubscription({
    stripeCustomerId: 'cus_LGjTfpPetblzoX',
    priceId: 'price_1L25ygFSbc2jn6YhZtz62sld'
  });

  if (loading){
    // TODO: should be using styled components, was used in demo video with oscar
    return (
      <div>
        <p> This is loading </p>
      </div>
    )
  }

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0
  });

  const options: StripeElementsOptions = {
    clientSecret: response.clientSecret,
    appearance: {
      theme: 'none',
      variables: {
        colorText: '#2E3A59',
        colorPrimary: '#FF2D55',
      },
    },
  };

  return (
    <PaymentDetailsContainer>
      <PaymentDetailsHeaderEnter> Enter your card details. </PaymentDetailsHeaderEnter>
      <PaymentDetailsHeaderStart> Your subscription will start now. </PaymentDetailsHeaderStart>

      <PaymentDetailsTextContainerDue>
        <PaymentDetailsArrow className={'fa-solid fa-arrow-right-long'}/>
        <PaymentDetailsInfoText> Total due now: <b> {formatter.format(plan.price / 100)} </b> </PaymentDetailsInfoText>
      </PaymentDetailsTextContainerDue>

      <PaymentDetailsTextContainerSubscribing>
        <PaymentDetailsArrow className={'fa-solid fa-arrow-right-long'}/>
        <PaymentDetailsInfoTextContainer>
          <PaymentDetailsInfoText>Subscribing to: <b> {plan.organizationType + " " + plan.name} </b></PaymentDetailsInfoText>
        </PaymentDetailsInfoTextContainer>
      </PaymentDetailsTextContainerSubscribing>
      {!response.error && <Elements stripe={stripePromise} options={options}>
        <StripeForm/>
      </Elements>}
    </PaymentDetailsContainer>
  )
}

export default PaymentDetails;
